import { render, staticRenderFns } from "./ShelfComponent.vue?vue&type=template&id=59fac845&scoped=true&"
import script from "./ShelfComponent.vue?vue&type=script&lang=js&"
export * from "./ShelfComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShelfComponent.vue?vue&type=style&index=0&id=59fac845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fac845",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VChip,VCol,VIcon,VRow})
